__turbopack_context__.v({
  "caret": "native_select_dropdown-module-scss-module__xVyuUG__caret",
  "disabled": "native_select_dropdown-module-scss-module__xVyuUG__disabled",
  "dropdown": "native_select_dropdown-module-scss-module__xVyuUG__dropdown",
  "select": "native_select_dropdown-module-scss-module__xVyuUG__select",
  "selectWrapper": "native_select_dropdown-module-scss-module__xVyuUG__selectWrapper",
});
